import React, { Component } from 'react';
import '../css/UserInstructions.css';


export class ToteStorage extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        var toteStorage = this.props.toteStorage;
        return (
            <div>
                <div className="shipGroup">
                    <h3>The following totes will be cleared and can be reused</h3>
                    <table className="shipGroupOrdersTable">
                        <th>Slot</th>
                        <th>Tote</th>
                        {toteStorage.map(function (order, orderIdx) {
                            return (
                                <tr>
                                    <td>{order.slot}</td>
                                    <td>{order.tote}</td>
                                </tr>
                            )
                        })}
                    </table>
                </div>
            </div>
        );
    }
}
